import { isPoint } from './is-point.js';

var isPoint3D = function (point) {
    return isPoint(point) && point.hasOwnProperty('z');
};

export { isPoint3D };



//////////////////
// WEBPACK FOOTER
// ./node_modules/popmotion/dist/es/utils/is-point-3d.js
// module id = null
// module chunks = 